"use client";

import clsx from "clsx";

/**
 * Extract the ticker symbol from a trading pair (e.g., "ES/USD" -> "ES")
 */
function extractSymbol(pair: string): string {
  return pair.split("/")[0];
}

interface ContractBadgeProps {
  asset: string;
}

export const ContractBadge = ({ asset }: ContractBadgeProps) => {
  const symbol = extractSymbol(asset);

  return (
    <span
      className={clsx(
        "inline-flex items-center rounded-md border border-slate-600/50 bg-slate-700/40 px-1.5 py-0.5 text-[10px] font-mono font-medium text-slate-300"
      )}
    >
      {symbol}
    </span>
  );
};
